import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../APIHelpers/Responses";

export const integrationServices = {
  addNewSitePilotIntegration,
  updatedSitePilotIntegration,
  softDeleteRestoreSitePilotIntegration,
  deleteSitePilotIntegration,
  getSitePilotIntegrationList,
  getSingleSitePilotIntegration,
};

// Add New Integration
async function addNewSitePilotIntegration(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewSitePilotIntegration`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Integration
async function updatedSitePilotIntegration(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedSitePilotIntegration`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Soft Delete & Restore Integration
async function softDeleteRestoreSitePilotIntegration(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreSitePilotIntegration`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Delete Integration
async function deleteSitePilotIntegration(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteSitePilotIntegration`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get All Integration
async function getSitePilotIntegrationList(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSitePilotIntegrationList/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSitePilotIntegrationList/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Single Integration
async function getSingleSitePilotIntegration(integrationId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSingleSitePilotIntegration/${integrationId}`,
      headersWithAuthWithoutBody("GET", headers)
    )
  const data = await response.json();
  return data;
}